"use client"

export { TextAnimate } from "@/components/ui/text-animate"
